import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { SET_MAIN_LOADER } from '../../redux/loaderSlice';

export let RePrintDataTitli = (place_bet, dispatch) => {
  let { card_details, mobile_number, is_advance } = place_bet;

  if (mobile_number) {
    // console.log("Mobile number present, skipping print...");
    dispatch(SET_MAIN_LOADER(false));
    return;
  }

  let PrintObj = {};
  Object.keys(card_details).map((key) => {
    let x = PrintObj[key.charAt(0)]?.totalValue || 0;
    let value = Number(card_details[key]);
    if (PrintObj[key.charAt(0)]) {
      PrintObj[key.charAt(0)].totalCount += 1;
      PrintObj[key.charAt(0)].totalValue +=
        Number(value) === x && x % 1 !== 0
          ? (value * 10 + 0.1 * 10) / 10
          : value;
      PrintObj[key.charAt(0)].seriesAllfield = [
        ...PrintObj[key.charAt(0)].seriesAllfield,
        { name: key, value: card_details[key] },
      ];
    } else {
      PrintObj[key.charAt(0)] = {
        totalCount: 1,
        totalValue:
          Number(value) === x && x % 1 !== 0
            ? (value * 10 + 0.1 * 10) / 10
            : value,
        multiply: 2,
        seriesAllfield: [{ name: key, value: card_details[key] }],
      };
    }
  });

  // ensure bet_details exist
  if (place_bet && !place_bet?.bet_details) {
    place_bet.bet_details = [
      {
        deal_date: place_bet?.deal_date,
        deal_time: place_bet?.deal_time,
        ticket_id: place_bet?.ticket_id,
      },
    ];
  }

  // 🧩 Single-page print for advance bets
  if (is_advance === true) {
    let combinedRenderData = "";
    place_bet.bet_details.forEach((betDetail, betIndex) => {
      combinedRenderData += ReactDOMServer.renderToString(
        <PrintComponet1
          detail={betDetail}
          LOTTERY_PLACE_BET={place_bet}
          key={`c1-${betIndex}`}
        />
      );
      combinedRenderData += ReactDOMServer.renderToString(
        <PrintComponet2
          printObj={PrintObj}
          LOTTERY_PLACE_BET={place_bet}
          key={`c2-${betIndex}`}
          betDetail={betDetail}
        />
      );
      combinedRenderData += "<hr style='border:1px dashed #000; margin:8px 0;' />";
    });

    openPrintWindow(combinedRenderData, dispatch);
  } else {
    // 🧾 normal (each bet in separate window)
    place_bet.bet_details.forEach((betDetail, betIndex) => {
      let renderData = "";
      renderData += ReactDOMServer.renderToString(
        <PrintComponet1
          detail={betDetail}
          LOTTERY_PLACE_BET={place_bet}
          key={betIndex}
        />
      );
      renderData += ReactDOMServer.renderToString(
        <PrintComponet2
          printObj={PrintObj}
          LOTTERY_PLACE_BET={place_bet}
          key={betIndex}
          betDetail={betDetail}
        />
      );
      openPrintWindow(renderData, dispatch);
    });
  }
};

// 🪟 Helper: opens a print window
function openPrintWindow(renderData, dispatch) {
  setTimeout(() => {
    try {
      let x = window.open("", "_blank");
      if (x) {
        x.document.open();
        x.document.write(`
          <html>
            <head>
              <title>Print</title>
              <style>
                body { font-family: 'Roboto', sans-serif; color: #000; font-weight: bold; } 
                .printArea { margin-left: 10px; font-size: 12px; font-weight: bold; color: black; } 
                .printArea p { margin: 0px; font-weight: bold; } 
                .serizContainer { display: flex; flex-wrap: wrap; width: 100%; justify-content: flex-start; } 
                .sirizList, .valContent { display: flex; font-weight: bold; font-size: 12px; justify-content: space-between; } 
                hr { margin-block-start: 0.1em; margin-block-end: 0.1em; } 
                @media print { @page { margin: 0 auto; margin-top: 0.5cm; size: 80mm auto; } body { margin: 0 auto; } }
              </style>
              <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
            </head>
            <body>
              <div class="printArea" style="width:50mm">
                ${renderData}
              </div>
              <script>
                let ticketIDArray = document.querySelectorAll('.ticketId');
                ticketIDArray.forEach(element => {
                  let ticketId = element.innerHTML;
                  JsBarcode('#barcode' + ticketId, ticketId, {
                    width: 1,
                    height: 40,
                    displayValue: false,
                    marginBottom: 20
                  });
                });
              </script>
            </body>
          </html>
        `);
        x.document.close();
        setTimeout(() => {
          x.print();
          x.close();
        }, 500);
      }
    } catch (error) {
      console.error("Error while printing:", error);
    } finally {
      dispatch(SET_MAIN_LOADER(false));
    }
  }, 1000);
}

// -------- Component 1 --------
const PrintComponet1 = ({ detail, LOTTERY_PLACE_BET }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", fontWeight: "bold" }}>
      <p>
         TITLI <br />
        For Amusement Only <br />
        Reprint Ticket <br />
        Agent ID : {LOTTERY_PLACE_BET?.user_name} <br />
        Ticket ID : <span style={{ fontSize: "14px" }}>{detail.ticket_id}</span> <br />
        Coupen Dr Time : {detail.deal_date} <br />
        Coupen Time : {detail.deal_time} <br />
        Total Point : <span style={{ fontSize: "13px" }}>
          {Math.floor(LOTTERY_PLACE_BET?.total_bet_amount)}
        </span>
      </p>
      <br />
    </div>
  );
};

// -------- Component 2 --------
let PrintComponet2 = ({ LOTTERY_PLACE_BET, printObj, betDetail }) => {
  // Combine all series items into a single array
  const allItems = Object.values(printObj)
    .map(obj => obj.seriesAllfield)
    .flat();

  return (
    <>
      <table
        width="100%"
        border="0"
        cellSpacing="0"
        style={{ fontSize: "12px", fontWeight: "bold" }}
      >
        <tbody>
          {allItems.map((item, i) => {
            if (i % 2 === 0) {
              return (
                <tr key={i}>
                  {/* Left item */}
                  <td align="left" style={{ width: "48%" }}>
                    {item?.name} * {item?.value / 10}
                  </td>

                  {/* Right item */}
                  <td align="left" style={{ width: "48%" }}>
                    {allItems[i + 1]
                      ? `${allItems[i + 1].name} * ${
                          allItems[i + 1].value / 10
                        }`
                      : ""}
                  </td>
                </tr>
              );
            }
            return null;
          })}
        </tbody>
      </table>

      {/* Barcode Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          marginTop: "5px",
        }}
      >
        <svg id={`barcode` + betDetail?.ticket_id}></svg>
        <p
          className="ticketId"
          style={{
            marginTop: 0,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {betDetail?.ticket_id}
        </p>
      </div>
    </>
  );
};
